// Tasks

export const GET_TASKS_START = 'GET_TASKS_START';
export const GET_TASKS_SUCCESS = 'GET_TASKS_SUCCESS';
export const GET_TASKS_FAIL = 'GET_TASKS_FAIL';

export const GET_TASK_STATUSES_START = 'GET_TASK_STATUSES_START';
export const GET_TASK_STATUSES_SUCCESS = 'GET_TASK_STATUSES_SUCCESS';
export const GET_TASK_STATUSES_FAIL = 'GET_TASK_STATUSES_FAIL';

export const CHANGE_TASK_STATUS_START = 'CHANGE_TASK_STATUS_START';
export const CHANGE_TASK_STATUS_SUCCESS = 'CHANGE_TASK_STATUS_SUCCESS';
export const CHANGE_TASK_STATUS_FAIL = 'CHANGE_TASK_STATUS_FAIL';

export const GET_TASK_PIPELINES_CONTROL_CONFIG_START = 'GET_TASK_PIPELINES_CONTROL_CONFIG_START';
export const GET_TASK_PIPELINES_CONTROL_CONFIG_SUCCESS = 'GET_TASK_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const GET_TASK_PIPELINES_CONTROL_CONFIG_FAIL = 'GET_TASK_PIPELINES_CONTROL_CONFIG_FAIL';

// Service Requests

export const GET_SERVICE_REQUESTS_START = 'GET_SERVICE_REQUESTS_START';
export const GET_SERVICE_REQUESTS_SUCCESS = 'GET_SERVICE_REQUESTS_SUCCESS';
export const GET_SERVICE_REQUESTS_FAIL = 'GET_SERVICE_REQUESTS_FAIL';

export const CHANGE_SERVICE_REQUEST_STATUS_START = 'CHANGE_SERVICE_REQUEST_STATUS_START';
export const CHANGE_SERVICE_REQUEST_STATUS_SUCCESS = 'CHANGE_SERVICE_REQUEST_STATUS_SUCCESS';
export const CHANGE_SERVICE_REQUEST_STATUS_FAIL = 'CHANGE_SERVICE_REQUEST_STATUS_FAIL';

export const GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START = 'GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START';
export const GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS = 'GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL = 'GET_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL';

export const GET_SERVICE_REQUESTS_STAGES_START = 'GET_SERVICE_REQUESTS_STAGES_START';
export const GET_SERVICE_REQUESTS_STAGES_SUCCESS = 'GET_SERVICE_REQUESTS_STAGES_SUCCESS';
export const GET_SERVICE_REQUESTS_STAGES_FAIL = 'GET_SERVICE_REQUESTS_STAGES_FAIL';

export const CHANGE_SERVICE_REQUEST_STAGE_START = 'CHANGE_SERVICE_REQUEST_STAGE_START';
export const CHANGE_SERVICE_REQUEST_STAGE_SUCCESS = 'CHANGE_SERVICE_REQUEST_STAGE_SUCCESS';
export const CHANGE_SERVICE_REQUEST_STAGE_FAIL = 'CHANGE_SERVICE_REQUEST_STAGE_FAIL';

export const GET_SERVICE_REQUESTS_CUSTOM_TYPES_START = 'GET_SERVICE_REQUESTS_CUSTOM_TYPES_START';
export const GET_SERVICE_REQUESTS_CUSTOM_TYPES_SUCCESS = 'GET_SERVICE_REQUESTS_CUSTOM_TYPES_SUCCESS';
export const GET_SERVICE_REQUESTS_CUSTOM_TYPES_FAIL = 'GET_SERVICE_REQUESTS_CUSTOM_TYPES_FAIL';

export const CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_START = 'CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_START';
export const CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_SUCCESS = 'CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_SUCCESS';
export const CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_FAIL = 'CHANGE_SERVICE_REQUEST_CUSTOM_TYPE_FAIL';

export const SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START = 'SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_START';
export const SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS = 'SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL = 'SAVE_SERVICE_REQUEST_PIPELINES_CONTROL_CONFIG_FAIL';

// Opportunities

export const GET_OPPORTUNITIES_START = 'GET_OPPORTUNITIES_START';
export const GET_OPPORTUNITIES_SUCCESS = 'GET_OPPORTUNITIES_SUCCESS';
export const GET_OPPORTUNITIES_FAIL = 'GET_OPPORTUNITIES_FAIL';

export const GET_OPPORTUNITIES_STAGES_START = 'GET_OPPORTUNITIES_STAGES_START';
export const GET_OPPORTUNITIES_STAGES_SUCCESS = 'GET_OPPORTUNITIES_STAGES_SUCCESS';
export const GET_OPPORTUNITIES_STAGES_FAIL = 'GET_OPPORTUNITIES_STAGES_FAIL';

export const CHANGE_OPPORTUNITY_STAGE_START = 'CHANGE_OPPORTUNITY_STAGE_START';
export const CHANGE_OPPORTUNITY_STAGE_SUCCESS = 'CHANGE_OPPORTUNITY_STAGE_SUCCESS';
export const CHANGE_OPPORTUNITY_STAGE_FAIL = 'CHANGE_OPPORTUNITY_STAGE_FAIL';

export const DELETE_OPPORTUNITY_START = 'DELETE_OPPORTUNITY_START';
export const DELETE_OPPORTUNITY_SUCCESS = 'DELETE_OPPORTUNITY_SUCCESS';
export const DELETE_OPPORTUNITY_FAIL = 'DELETE_OPPORTUNITY_FAIL';

export const GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_START = 'GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_START';
export const GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_SUCCESS = 'GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_FAIL = 'GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_FAIL';

export const SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_START = 'SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_START';
export const SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_SUCCESS = 'SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_FAIL = 'SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_FAIL';

// Endorsements

export const GET_ENDORSEMENTS_START = 'GET_ENDORSEMENTS_START';
export const GET_ENDORSEMENTS_SUCCESS = 'GET_ENDORSEMENTS_SUCCESS';
export const GET_ENDORSEMENTS_FAIL = 'GET_ENDORSEMENTS_FAIL';

export const GET_ENDORSEMENT_STATUSES_START = 'GET_ENDORSEMENT_STATUSES_START';
export const GET_ENDORSEMENT_STATUSES_SUCCESS = 'GET_ENDORSEMENT_STATUSES_SUCCESS';
export const GET_ENDORSEMENT_STATUSES_FAIL = 'GET_ENDORSEMENT_STATUSES_FAIL';

export const CHANGE_ENDORSEMENT_STATUS_START = 'CHANGE_ENDORSEMENT_STATUS_START';
export const CHANGE_ENDORSEMENT_STATUS_SUCCESS = 'CHANGE_ENDORSEMENT_STATUS_SUCCESS';
export const CHANGE_ENDORSEMENT_STATUS_FAIL = 'CHANGE_ENDORSEMENT_STATUS_FAIL';

export const GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_START = 'GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_START';
export const GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_SUCCESS = 'GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_SUCCESS';
export const GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_FAIL = 'GET_ENDORSEMENT_PIPELINES_CONTROL_CONFIG_FAIL';
